module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-regular.479970ff.woff2";